import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import { URLS } from '../../_config';
import Icon from '../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import { data, useLocation, useNavigate } from 'react-router-dom';
import Drawer from '../../components/Drawer';
import CreateChecklist from './_components/createChecklist';
import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Search from '../../components/search';
import moment from 'moment';
import { statusChangeDataType } from '../../_common/types';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../_common/functions';
import Loader from '../../components/loader';
import { filterConfigType } from '../../_config/types';
import Filters from '../../components/filters';
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from '../../store/selectors/masterSelector';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import { titleCell } from '../../components/elements/function';
import StatusChangeReasonModal from '../Assets/_components/statusChangeReason.modal';
import { useChecklistApi } from '../../store/api/hooks/checklistApiHook';
import { useUserSelector } from '../../store/selectors/userSelector';

const Checklist: React.FC = () => {
    const assetsAPI = useAssetsApi();
    const navigate = useNavigate();
    const facilityApi: any = useFacilitiesApi();
    const checklistAPI: any = useChecklistApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [duplicateFrom, setDuplicateFrom] = useState<any>(null);

    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
    const [statusChangeData, setStatusChangeData] = useState<statusChangeDataType>(null);

    const statusChangeReasonModalRef: any = useRef()

    const [statuslist, setstatusList] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);

    const { confirm } = useDialog();
    const location = useLocation();
    const loggedinuser: any = useUserSelector();


    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Checklist No', field: 'checkListCode', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.CHECKLIST_CREATE(param.data.checkListID));
            }
        },
        { headerName: 'Title ', field: 'title', headerClass: 'bg-[#f0f0f0]', width: 300, cellRenderer: titleCell },
        { headerName: 'Description', field: 'description', headerClass: 'bg-[#f0f0f0]', flex: 1, width: 160, cellRenderer: titleCell },
        { headerName: 'Is Walkthrough', field: 'isWorkThrough', headerClass: 'bg-[#f0f0f0]', width: 140, cellRenderer: (data: any) =>{
            return data.value ? 'Yes' : 'No'
        } },
        // { headerName: 'Type', field: 'checkListTypeName', headerClass: 'bg-[#f0f0f0]', minWidth: 160, cellRenderer: titleCell },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,
            pinned: 'right',
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                const action = e.target.value;

                                if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                }

                                handleActionChange(e, params);
                                //e.target.value = '';
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)} value="edit">Edit</option>
                            <option disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)} value="delete">Delete</option>
                            <option disabled={!getPermissionInfo(location.pathname, "Duplicate", loggedinuser)} value="duplicate">Duplicate</option>
                        </select>
                    </div>
                );
            }
        }
    ]

    // Define row data
    const [rowData, setRowData] = useState<any>(null)
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });

    const assetsCategories = useAssestCategoriesSelector();
    const assetsDepartments = useAssestDepartmentsSelector();
    const assetsGroups = useAssestGroupsSelector();
    const assetsSubGroups = useAssestSubGroupsSelector();
    const assetsTypes = useAssestTypesSelector();
    const assetsClassifications = useAssestClassificationsSelector();
    const assetsStatues = useAssestStatuesSelector();

    useEffect(() => {
        if (assetsCategories == null) {
            assetsAPI.getAssetCategpry({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsCategories]);

    useEffect(() => {
        if (assetsDepartments == null) {
            assetsAPI.getAssetdepartment({pageSize: 5000,
                pageNumber: 1,}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsDepartments]);

    useEffect(() => {
        if (assetsGroups == null) {
            assetsAPI.getAssetGrouplist({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsGroups]);

    useEffect(() => {
        if (assetsSubGroups == null) {
            assetsAPI.getAssetSubGrouplist({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsSubGroups]);

    useEffect(() => {
        if (assetsTypes == null) {
            assetsAPI.GetAssetTypeList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsTypes]);

    useEffect(() => {
        if (assetsClassifications == null) {
            assetsAPI.GetAssetClassificationList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsClassifications]);

    useEffect(() => {
        if (assetsStatues == null) {
            assetsAPI.GetAssetStatusList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsStatues]);

    const getAssetsList = (s: string) => {
        return new Promise((resolve, reject) => {

            let payload: any = { statusIDs: [1, 2, 3, 4, 5, 6].join(`,`) };
            if (s !== '') {
                payload.searchParam = s;
            }

            assetsAPI.getAssetsList(payload, (data: any) => {
                resolve(data.assetList ? data.assetList.map((asset: any) => {
                    return {
                        label: asset.name,
                        value: asset.assetID
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    }


    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('checklistFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('checklistFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const filterConfig: filterConfigType[] = [
        { name: 'Asset', type: 'dropdown', key: 'assetIDs', async: getAssetsList as any },
    ]

    const getChecklists = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        checklistAPI.getChecklists(
            payload,
            (resp: any) => {
                let _rowData: any = resp.checklistList ? resp.checklistList : []
                // as per API team they cannot group by assets, so we are doing it here
                _rowData = Array.from(
                    new Map(_rowData.map((item: any) => [item.checkListID, item])).values()
                );

                setRowData(_rowData);
                setTotalRecords(resp.totalRecord);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };




    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const checklistIDs = selectedData.map((checklist: any) => checklist.checkListID).join(',');
            const payload = { checklistIDs: checklistIDs };
            checklistAPI.Exportcsv(
                payload,
                (resp: any) => { downloadExcel(resp, 'checklists') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };



    const GetAssetStatusList = () => {
        const payload = {};
        assetsAPI.GetAssetStatusList(
            payload,
            (resp: any) => {
                let deptlist: any = [];

                resp.assetStatusList.map((facilist: any) => {
                    deptlist.push({
                        label: facilist.statusName,
                        value: facilist.statusID,
                    });
                });
                setstatusList(deptlist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        // Check permission before performing any action
        if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
            toast.error(`You don't have ${action} permission`);
            e.target.selectedIndex = -1;
            return;
        }

        switch (action) {
            case "edit":
                // Implement edit action
                setEditData(rowData);
                addNewAssetRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Asset',
                    message: 'Are you sure you want to delete this asset?',
                    onConfirm: () => {
                        console.log("Delete action for row: ", rowData);
                        checklistAPI.deleteChecklist({ CheckListID: rowData.checkListID }, (data: any, msg: any) => {
                            toast.success(msg);
                            getChecklists();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            case "duplicate":
                console.log("Duplicate action for row: ", rowData);
                setDuplicateFrom(rowData);
                addNewAssetRef?.current?.open();
                createAssetRef?.current?.setValue('name', rowData.title);
                createAssetRef?.current?.setValue('description', rowData.description);
                break;
            case "move-asset":
                // Implement move asset action
                console.log("Move Asset action for row: ", rowData);
                break;
            case "qr":
                console.log("QR Code action for row: ", rowData);

                const payload = { qrAssetList: [{ assetID: rowData.assetID, qty: 1 }], assetNameInQR: true };
                assetsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'AssetsQr') },
                    (error: any) => {
                        console.log("error =>", error);
                        toast.error(error);
                    }
                );
                break;
            case "schedule-maintenance":
                // Implement schedule maintenance action
                console.log("Schedule Maintenance action for row: ", rowData);
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };


    useEffect(() => {
        GetAssetStatusList();
    }, []);

    // Call getChecklists only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getChecklists();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {

        console.log("statuslist", statuslist);
    }, [statuslist]);

    useEffect(() => {
        if (filtersInitialized) {
            getChecklists();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters]);

    // Auto-open create checklist drawer if URL has openCreateChecklist parameter
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.get('openCreateChecklist') === 'true') {
            addNewAssetRef?.current?.open();
            // Remove the parameter from URL after opening
            const newUrl = window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    }, [location]);

    // console.log("statuslist", statuslist);
    const createAssetRef: any = useRef();
    return (
        <Layout>
            <Header title='Checklists'>
                <Header.Right>
                    <Drawer _ref={addNewAssetRef} onClose={() => {
                        setEditData(null);
                        setDuplicateFrom(null);
                        createAssetRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, editData ? 'Edit' : 'Add', loggedinuser)}>{editData ? 'Edit' : 'Create'} Checklist</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Checklist' : 'Add New Checklist'} className='!w-[39.563rem]'>

                            <CreateChecklist _ref={createAssetRef} editData={editData} refChecklist={duplicateFrom} onCreate={() => {
                                setEditData(null);
                                addNewAssetRef?.current?.close();
                                if (duplicateFrom) {
                                    setDuplicateFrom(null);
                                    getChecklists();
                                } else {
                                    getChecklists();
                                }
                            }} onCancel={() => {
                                setEditData(null);
                                addNewAssetRef?.current?.close();
                            }} />

                        </Drawer.Content>
                    </Drawer>
                    {/*
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary' disabled>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility'>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                        </Dropdown.Content>
                    </Dropdown>
                    */}
                </Header.Right>
            </Header>
            {/* <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} />
            </div> */}
            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { setFilters({}) }} >Clear Filters</p>
                </div>

                <div className="ag-theme-alpine mx-4  h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any} // Pass columnDefs
                        rowData={rowData || []} // Pass rowData
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>



            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default Checklist;